// components/Toast.jsx
import React, { useState, useEffect } from 'react';

const Toast = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const handleClick = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  if (!isVisible) return null;

  const bgColor = type === 'success' ? 'bg-green-500' : 
                  type === 'error' ? 'bg-red-500' : 
                  type === 'warning' ? 'bg-yellow-500' : 
                  'bg-blue-500';

  const icon = type === 'success' ? 'fa-check-circle' : 
               type === 'error' ? 'fa-exclamation-circle' : 
               type === 'warning' ? 'fa-exclamation-triangle' : 
               'fa-info-circle';

  return (
    <div 
      className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 cursor-pointer"
      style={{
        animation: 'fadeInDown 0.3s ease-out forwards'
      }}
      onClick={handleClick}
    >
      <div className={`${bgColor} text-white px-6 py-3 rounded-lg shadow-lg flex items-center min-w-[200px] max-w-[90vw]`}>
        <i className={`fas ${icon} mr-3 text-lg`}></i>
        <span className="font-medium">{message}</span>
      </div>
    </div>
  );
};

// Añadir estilos inline para la animación
const toastStyles = document.createElement('style');
toastStyles.textContent = `
  @keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translate(-50%, -20px);
    }
    100% {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }
`;

// Inyectar estilos solo una vez
if (!document.querySelector('#toast-styles')) {
  toastStyles.id = 'toast-styles';
  document.head.appendChild(toastStyles);
}

export default Toast;